export const HOME = {
  emergentLink: 'home-emergent-link',
  heroCta: 'hero-cta-primary',
  heroSecondary: 'hero-cta-secondary',
  publishCta: 'hero-cta-publish',
};

export const NAV = {
  logo: 'nav-logo',
  explore: 'nav-explore',
  map: 'nav-map',
  publish: 'nav-publish',
  how: 'nav-how-it-works',
  login: 'nav-login',
  register: 'nav-register',
  dashboard: 'nav-dashboard',
  logout: 'nav-logout',
  mobileToggle: 'nav-mobile-toggle',
};

export const AUTH = {
  loginForm: 'login-form',
  loginEmail: 'login-email',
  loginPassword: 'login-password',
  loginSubmit: 'login-submit',
  loginGoogle: 'login-google',
  registerForm: 'register-form',
  registerName: 'register-name',
  registerEmail: 'register-email',
  registerPassword: 'register-password',
  registerRoleUser: 'register-role-user',
  registerRoleOwner: 'register-role-owner',
  registerSubmit: 'register-submit',
};

export const LISTING = {
  card: (id) => `listing-card-${id}`,
  contactBtn: 'listing-contact-btn',
  saveBtn: 'listing-save-btn',
  matchBadge: 'listing-match-badge',
};

export const PUBLISH = {
  step: (n) => `publish-step-${n}`,
  next: 'publish-next',
  prev: 'publish-prev',
  submit: 'publish-submit',
};
